<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 11:38:26
 * @LastEditTime: 2024-06-24 14:26:31
 * @LastEditors: 张天昊
 * @Description: 描述
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/Description.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import { px2rem } from '@/utils/px2rem';

export default defineComponent({
  props: {
    flex: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: true
    },
    labelWidth: {
      type: Number
    },
    content: {
      type: String,
      default: ''
    },
    // light default dark
    theme: {
      type: String
    },
    size: {
      type: String
    }
  },
  setup(props) {
    const computedLabelWidth = computed(() => {
      return props.labelWidth && props.labelWidth > 0
        ? { width: px2rem(props.labelWidth) }
        : void 0;
    });
    return {
      computedLabelWidth
    };
  }
});
</script>

<template>
  <div
    class="leading-20 break-all"
    :class="[size === 'small' ? 'text-14' : 'text-16', { flex }]"
  >
    <span
      class="align-middle flex-shrink-0 whitespace-nowrap"
      :class="
        theme === 'light'
          ? 'text-white'
          : theme === 'dark'
          ? 'text-black-a'
          : 'text-grey-f'
      "
      :style="computedLabelWidth"
      >{{ label }}：</span
    >
    <slot :label-width="computedLabelWidth ? computedLabelWidth.width : void 0">
      <span
        class="align-middle break-all"
        :class="theme === 'light' ? 'text-white' : 'text-black-a'"
        v-html="(content || '').replace(/(\r\n)|(\n)/g, '<br>')"
      />
    </slot>
  </div>
</template>
